import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

import Layout from '../components/layout';
import { useSessionId } from '../hooks/useSessionId';
import { Message } from '../types/models/message';

import { getAllMessages } from '../services/messagesServices';
import { DOMAIN_NAME } from '../config/api';

const MessagesPage = () => {
  const [mails, setMails] = useState<Message[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const sessionId = useSessionId();

  useEffect(() => {
    setIsLoading(true);

    getAllMessages(sessionId).then(([error, result]) => {
      setIsLoading(false);

      if (error || !result) {
        return;
      }

      const responseData = result.data;
      if (responseData?.mails) {
        setMails(responseData.mails);
      }
    });

  }, [sessionId]);

  const renderMessagesList = () => {
    if (!isLoading && mails.length) {
      return mails.map((message, key) => (
        <li key={key}>
          <Link
            to={`/messages/${message.id}`}
            className="link cursor-pointer hover:text-royalblue"
          >
            {message.subject}
          </Link>
        </li>
      ));
    }

    if (!isLoading && !mails.length) {
      return <p className="text-center">Сообщений нет.</p>;
    }

    return <p className="text-center">Загрузка...</p>;
  };

  return (
    <Layout>
      <Helmet>
        <title>{`Мои сообщения | ${DOMAIN_NAME}`}</title>
      </Helmet>
      <div className="box box--bordered">
        <ul className="list-messages">{renderMessagesList()}</ul>
      </div>
    </Layout>
  );
};

export default MessagesPage;
